import * as React from "react";
const Component = props => <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" viewBox="0 0 1000 1000" {...props}><rect width="100%" height="100%" fill="transparent" /><path d="M1068 2210c-23-17-27-18-47-4-29 21-84 11-108-19-15-19-26-22-59-19-51 5-82-10-90-44-6-21-10-24-38-18-26 4-39 0-64-21-17-14-32-35-34-47-2-15-11-22-33-24-37-4-85-54-85-89 0-18-5-25-19-25-11 0-31-14-46-32-21-24-26-39-22-63 4-27 1-33-23-44-36-15-57-69-40-101 10-18 8-25-14-45-33-31-41-67-24-103 13-26 13-31-4-51-23-30-23-82 0-112 17-20 17-25 5-51-19-36-9-82 23-107 21-16 23-23 14-46-14-37 10-92 44-101 21-5 24-10 20-34-9-41 20-88 59-98 17-5 31-14 29-21-1-6 4-27 12-46 14-33 28-41 82-49 10-2 20-11 22-22 2-10 11-30 22-44 15-20 27-25 64-24 39 1 45-2 51-23 8-34 66-60 99-45 22 10 29 8 55-18 33-33 75-39 106-16 17 12 22 12 44-5 30-24 82-24 112 0 21 17 25 17 46 4 31-21 87-9 112 23 17 22 22 23 45 12 36-16 93 10 102 47 6 22 11 26 32 20 48-12 86 16 106 78 3 11 16 17 33 17 15 0 33 4 39 8 20 14 44 57 44 78 0 16 8 23 30 27 36 8 65 57 56 97-4 24-1 29 20 34 34 9 59 67 45 106-8 25-6 31 14 44 30 20 41 68 22 104-12 26-12 31 5 51 23 30 23 82 0 112-17 20-17 25-5 51 19 37 9 82-23 106-23 16-24 21-13 44 16 36-3 83-41 100-24 10-27 16-23 43 6 36-34 92-69 97-15 2-22 11-22 30-2 37-41 76-80 80-23 2-32 9-34 24-5 37-49 69-92 68-33-1-39 2-45 23-8 33-64 57-100 43-23-9-30-7-46 15-25 31-81 43-112 22-21-13-25-13-46 4-30 25-82 24-113-1m92-30c11-11 20-27 20-35s-9-24-20-35-27-20-35-20-24 9-35 20-20 27-20 35 9 24 20 35 27 20 35 20 24-9 35-20m-142-12c7-7 12-24 12-38 0-33-17-50-50-50-14 0-31 5-38 12-15 15-15 61 0 76 7 7 24 12 38 12s31-5 38-12m290 0c7-7 12-24 12-38s-5-31-12-38-24-12-38-12-31 5-38 12c-15 15-15 61 0 76 7 7 24 12 38 12s31-5 38-12m-430-40c15-15 15-61 0-76-7-7-24-12-38-12-33 0-50 17-50 52 0 41 59 65 88 36m563 2c22-12 26-59 7-78-7-7-24-12-38-12s-31 5-38 12-12 24-12 38c0 45 37 63 81 40m-685-85c15-23 15-27 0-50-28-42-96-24-96 25s68 67 96 25m824 4c17-30 4-68-25-75-34-8-53 1-67 31-9 21-8 28 7 45 24 27 71 26 85-1m-390-28c77-40 100-123 60-216-11-26-20-50-20-54s15-12 34-18l35-11 21 53c46 114 143 151 237 90 35-24 66-98 58-141-9-48-56-98-117-124-29-12-54-23-56-25-3-2 28-65 33-65 2 0 24 9 50 20 93 40 176 17 216-60 24-43 24-85 1-130-38-76-124-100-218-60-50 22-54 21-71-21-11-26-10-28 34-44 104-40 150-118 118-202-33-87-119-122-200-83-39 19-50 31-77 90-31 66-32 67-60 58-39-14-41-20-18-73 40-93 17-176-60-216-66-36-144-14-187 50-29 42-29 94-3 163 11 29 20 54 20 56s-14 9-32 16l-32 14-26-57c-49-103-120-140-202-103-60 26-92 72-92 131 0 69 27 106 104 144 80 38 76 35 62 49-7 7-12 20-12 30 0 23-8 23-61-2-91-41-184-16-221 60-22 46-22 87 1 130 40 77 123 100 216 60 57-24 61-25 68-2 2 9 8 24 11 33 5 12-4 20-40 34-125 48-167 158-93 248 52 63 154 69 212 11 14-14 36-49 48-78l22-53 33 10c19 6 34 14 34 18s-9 28-20 54c-27 63-26 123 3 165 26 39 80 70 122 70 17 0 46-8 65-19m-552-53c15-15 15-61 0-76-7-7-24-12-38-12-33 0-50 17-50 52 0 41 59 65 88 36m1047-4c39-40-14-110-60-80-23 16-32 61-14 82 15 19 54 18 74-2M544 1854c24-24 20-61-9-80-23-15-27-15-50 0-17 11-25 26-25 46 0 45 52 66 84 34m1227 6c29-16 25-65-6-86-23-15-27-15-50 0-29 19-32 51-8 78 18 20 36 23 64 8M471 1730c29-16 25-65-6-86-23-15-27-15-50 0-44 29-28 95 23 96 7 0 22-5 33-10m1373-6c24-24 20-61-9-80-23-15-27-15-50 0-17 11-25 26-25 46 0 45 52 66 84 34M442 1575c17-38-3-75-42-75-21 0-34 8-46 25-15 23-15 27 0 50 12 17 25 25 46 25 23 0 33-6 42-25m1454 0c15-23 15-27 0-50-30-46-96-26-96 29 0 46 69 61 96 21M420 1440c11-11 20-27 20-35 0-21-36-55-59-55-20 0-51 35-51 57 0 18 37 53 55 53 8 0 24-9 35-20m1482 3c10-9 18-26 18-39 0-23-33-54-57-54-18 0-53 37-53 55 0 20 36 55 57 55 9 0 25-7 35-17M438 1298c7-7 12-24 12-38 0-64-81-71-103-9-14 42 59 79 91 47m1450 0c7-7 12-24 12-38s-5-31-12-38c-19-19-66-15-78 7-23 44-5 81 40 81 14 0 31-5 38-12M478 1158c7-7 12-24 12-38 0-33-17-50-50-50s-50 17-50 50c0 14 5 31 12 38 15 15 61 15 76 0m1371-2c22-26 9-69-22-80-36-13-61 2-65 38-4 35 14 56 48 56 15 0 33-6 39-14M538 1034c26-18 28-50 5-76-33-37-83-17-83 33 0 24 30 59 50 59 3 0 16-7 28-16m1230 0c33-23 27-75-10-88-55-19-93 55-46 88 28 20 28 20 56 0M638 918c7-7 12-24 12-38 0-33-17-50-50-50s-50 17-50 50c0 14 5 31 12 38 15 15 61 15 76 0m1050 0c7-7 12-24 12-38 0-33-17-50-50-50s-50 17-50 50c0 14 5 31 12 38 15 15 61 15 76 0M760 807c14-27 14-29-13-52-29-25-52-24-74 3-18 22-16 47 3 67 24 24 66 15 84-18m814 17c38-37 5-91-51-85-7 0-20 12-29 26-15 23-15 27 0 50 19 29 56 33 80 9m-696-66c7-7 12-24 12-38s-5-31-12-38-24-12-38-12-31 5-38 12c-15 15-15 61 0 76s61 15 76 0m570 0c7-7 12-24 12-38 0-33-17-50-50-50s-50 17-50 50c0 14 5 31 12 38 15 15 61 15 76 0m-437-38c22-12 26-59 7-78-15-15-61-15-76 0-17 17-15 54 4 72 18 19 38 20 65 6m290 0c22-12 26-59 7-78-15-15-61-15-76 0-18 18-15 65 6 77 22 13 39 13 63 1m-141-20c11-11 20-26 20-33 0-24-31-57-55-57s-55 33-55 57c0 18 37 53 55 53 8 0 24-9 35-20" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.5956 0 0 -.5956 -170.09 1336.955)" /><path d="M1090 1957c-53-27-51-73 13-216l23-53 37 91c20 50 37 101 37 115 0 52-62 88-110 63" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.5956 0 0 -.5956 -170.086 1336.956)" /><path d="M748 1812c-24-12-34-25-36-46-7-61 2-71 104-116 52-23 97-40 100-37 4 3-34 100-66 169-18 39-60 51-102 30" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.5956 0 0 -.5956 -170.087 1336.957)" /><path d="M1445 1820c-12-4-26-14-32-22-16-18-85-180-79-185 6-6 166 62 187 81 22 19 26 87 6 104-23 19-62 30-82 22" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.5956 0 0 -.5956 -170.084 1336.957)" /><path d="M1008 1667c-25-12-26-13-12-45 13-32 12-34-21-67-33-34-34-34-69-20l-35 15-11-36c-14-40-14-38 23-50 15-5 27-12 27-16v-51c0-40-2-44-34-55l-35-13 17-32c9-18 18-33 19-35 0-2 15 4 31 12 30 15 31 15 66-20 34-34 34-36 21-68-14-32-13-33 20-48l33-15 16 34c14 30 19 33 61 33s47-3 61-34c16-33 17-33 48-18 17 8 32 16 34 18 2 1-4 16-12 33-16 30-16 30 20 65 35 34 37 35 65 21 37-19 35-20 48 16 14 42 16 38-22 54-31 13-32 15-29 59 3 39 9 49 33 62 16 8 29 16 29 18s-5 17-11 34c-11 31-11 32-45 17-35-14-36-14-70 20s-34 35-19 66c9 17 15 32 13 33s-16 8-33 15c-25 11-31 10-42-5-7-10-13-24-13-31 0-9-16-13-53-13-49 0-53 2-64 30-12 33-16 34-55 17m197-187c24-25 30-39 30-75 0-37-6-50-33-77s-40-33-77-33-50 6-77 33c-76 76-15 201 92 187 20-3 46-16 65-35" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.5956 0 0 -.5956 -170.087 1336.958)" /><path d="M587 1462c-9-10-20-32-23-49-5-26-1-37 19-57 35-34 60-33 168 10l91 37-89 38c-98 43-142 48-166 21" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.5956 0 0 -.5956 -170.088 1336.959)" /><path d="M1500 1444c-47-20-86-37-88-39-6-6 180-75 204-75 32 0 74 42 74 75 0 35-42 75-77 75-15-1-66-17-113-36" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.5956 0 0 -.5956 -170.084 1336.959)" /><path d="M813 1158c-77-34-93-45-102-70-14-39 3-78 42-96 46-22 76 1 118 88 42 86 54 120 42 119-4 0-49-18-100-41" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.5956 0 0 -.5956 -170.088 1336.96)" /><path d="M1330 1196c0-4 53-132 70-168 34-72 140-48 140 32 0 47-15 60-118 104-85 36-92 39-92 32" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.5956 0 0 -.5956 -170.084 1336.96)" /><path d="M1117 1103c-19-31-67-169-67-193 0-34 40-70 77-70 31 0 73 42 73 74 0 26-55 174-70 189-4 5-10 5-13 0" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.5956 0 0 -.5956 -170.086 1336.96)" /></svg>;
export default Component;
export { Component as ReactComponent };